import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Globals } from './global';
import { UtilityService } from './utility.service';
// import * as $ from 'jquery';
import $ from 'jquery';

import { Subject } from 'rxjs';
import { AgoraConfigService } from 'src/AgoraConfigService';


@Injectable({
  providedIn: 'root'
})
export class AttendeeService {

  commonHeaders: any;
  agoraConfigObject: any;

  constructor(private http: HttpClient, private globals: Globals, private utilService: UtilityService, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.commonHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
      .set("Access-Control-Allow-Headers", "*")
      .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  private dataSubject = new Subject<any>();

  sendData(data: any) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  } 
  loadUserDetails() {
    let request = { "orgCode": this.globals.orgCode, "userType": this.globals.userType, "userId": this.globals.userId, "orgId": this.globals.orgId }
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}`+"/getUserList", request, { headers: this.commonHeaders });
  }
  addAttendee(_jsonRequest: any) {
    //
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}`+"/createAttendee", _jsonRequest, { headers: this.commonHeaders });
  }

  editAttendee(_jsonRequest: any) {
    //
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/updateAttendee/${_jsonRequest['attendeeId']}`, _jsonRequest, { headers: this.commonHeaders });
  }

  fetchAttendeeById(attendeeId: any) {
    //
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/fetchAttendee/${attendeeId}`, { headers: this.commonHeaders });
  }

  checkUserAvailability(_jsonRequest: any) {
    //
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.meeting}`+"checkUserAvailability", _jsonRequest, { headers: this.commonHeaders });
  }


  getRoleList() {
    let reqParam = { "parentCode": "CHN" };
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/getUserRoleList/${environment.parentCode}`, { headers: this.commonHeaders });
  }

  deleteAttendee(attendeeId: any) {
    // alert("inside del service call** " + attendeeId);
    return this.http.delete<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/deleteAttendee/${attendeeId}`, { headers: this.commonHeaders });
  }
  fetchAttendee(meetingId: any) {
    let reqParam = { "parentCode": "CHN" };
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/getAttendeeListByMeetingId/` + meetingId, { headers: this.commonHeaders });
  }

  saveAttendeeLog(_jsonRequest: any){
    //
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/saveAttendeeLog`, _jsonRequest, { headers: this.commonHeaders });
  }
//get attendee tarck logs
  getAttendeeLog(attendeeId:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/getAttendeeLog/`+attendeeId, { headers: this.commonHeaders, observe: 'response' });
  }
  getAttendeeListById(meetingId:any) {
    return this.http.get<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/fetchAttendeeListObjectByMeeting/`+meetingId, { headers: this.commonHeaders, observe: 'response' });
  }
  updateAttendeeLog(attendeeLogJson:any) {
    return this.http.patch<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/updateAttendeeLog/`+attendeeLogJson.attendeeLogId,attendeeLogJson, { headers: this.commonHeaders, observe: 'response' });
  }

  saveAttendeeLoginflag(jsonReq:any) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.attendee}/saveAttendeeLogin/` + jsonReq.meetingId, jsonReq.userId, { headers: this.commonHeaders, observe: 'response' });
  }


  loadAttendeeAgendaPresenters(id: any, code: any, obj: any,userlist:any,addUser:any) {
    
    return new Promise((resolve, reject) => {
      var elem: any;
      var edtElem: any;
      var edtTaskElem: any;
      var editTask:any;
      var insertTpl = "";
      var acceptSpaceBar = false;
      var suffix = "";
      var attdplysec = false;
      var highlightFirst = false;
    
      
        elem = $(obj);
        highlightFirst = true;
        if ($(obj).attr("entitytype") == environment.taskEntityType) {
          insertTpl = "${value},";
        } else {
          insertTpl = "${value}";
        }
        suffix = " ";
      
   
      if(code=="ATTs"){
        var dup_facilitatorvalues="";
        userlist.forEach((user:any)=>{
          dup_facilitatorvalues+=user.fkSecUserAttendee+",";
        })
        addUser.forEach((user:any)=>{
          dup_facilitatorvalues+=user.fkSecUserAttendee+","
        })
      }
      this.fetchUserListSource("").then((result: any) => {
        var source: any = "";
        var resultLen = result.length;
        
          if(dup_facilitatorvalues!=undefined){
           
            var all_facilitatorvalues: any = dup_facilitatorvalues.split(',');
      
        $.each(result, function (i, el) {
          if (id) {
              var index = $.inArray(el["userId"] + "", all_facilitatorvalues);
          } else {
            var index = -1;
          }
          if (index != null && (index < 0)) {
            var newname = "";
            if (el["userLastname"] != '') {
              newname = el["userFirstname"] + " " + el["userLastname"];
            } else {
              newname = el["userFirstname"];
            }
            source += '{"value":"' + newname.trim() + '","label":"'
              + newname + '-' + el["userEmail"] + '","email":"' + el["userEmail"]
              + '","id":"' + el["userId"] + '","isExternal":"' + el["userIsExternal"] + '"}';
          }
          if (i != resultLen - 1) {
            if (source.substring(source.length - 1, source.length) != ",") {
              source += ",";
            }
          }
        });
      }
        if (source != null && source != "") {
          if (source.charAt(source.length - 1) == ',') {
            source = source.substr(0, source.length - 1);
          }
          if (source[0] == ",") {
            source = source.substring(1, source.length);
          }
          if (source != null && source != "" && source != "null" && source != undefined) {
            source = "[" + source + "]";
          }
        }
        if (source == null || source == "" || source == "null" || source == undefined || source == "undefined") {
          source = "[]";
        }
        if (source != null && source != "" && source != "null" && source != undefined) {
          source = JSON.parse(source);
        }
        if (source == null || source == "" || source == "null" || source == undefined || source == "undefined") {
          source = [];
        }
        var options = {
          at: "@",
          show_the_at: true,
          insertTpl: insertTpl,
          startWithSpace: false,
          headerTpl: '<div class="atwho-header">Users List<small>↑&nbsp;↓&nbsp;</small></div>',
          displayTpl: "<li email='${email}' id='${id}' userName='${value}'>${value}<br/><small>${email}</small></li>",
          spaceSelectsMatch: false,
          data: source,
          searchKey: "label",
          acceptSpaceBar: acceptSpaceBar,
          suffix: suffix,
          attdplysec: attdplysec,
          highlightFirst: highlightFirst,

          callbacks: {
            afterMatchFailed: function (at:any, el:any) {
              if (at == '@') {
                var newTag = el.text().trim().slice(1);
                var newData = el.text().trim();      
              }
            },
          },
        };
        if (edtElem != null) {
          var $inputor = edtElem.atwho(options);
        } else if(elem!=null) {
          var $inputor = elem.atwho(options);
        }else if(edtTaskElem!=null) {
          var $inputor = edtTaskElem.atwho(options);
        }else if(editTask!=null) {
           var $inputor = editTask.atwho(options);
         }
        resolve($inputor);
      });
    });
  }

  
  loadAttendeeAgendaPresenter(id: any, code: any, obj: any) {
    return new Promise((resolve, reject) => {
      var elem: any;
      var edtElem: any;
      var edtTaskElem: any;
      var editTask:any;
      var insertTpl = "";
      var acceptSpaceBar = false;
      var suffix = "";
      var attElem = $("#displayAttendeeSec");
      var editTaskElem = $("#taskEditReassign");
      var taskAttElem = $("#accordion-header-attendee-0");
      var totAttVal: any[] = [];

      var attDupl: any = "";
      var dup:any = "";
      var attdplysec = false;
      var highlightFirst = false;
      var pageIns = this;
      if (code == "ATT") {
        ////consolee.log("inside service>>>***")
        elem = $("#insertAttendeeSec");
        insertTpl = "${value}" + '';
        acceptSpaceBar = true;
        suffix = "";
        attdplysec = true;
        highlightFirst = true;
      } else if (code == "AG") {
        
        elem = $(obj);
        insertTpl = "${value},";
        //this.globals.globalAgendaPresenterSource = {};
        suffix = " ";
        acceptSpaceBar = true;
        highlightFirst = true;
      } else if (code == "EDTATT") {
        edtElem = $("#editAttendeeNameId");
        insertTpl = "${value}" + '';
        acceptSpaceBar = true;
        suffix = "";
        attdplysec = true;
        highlightFirst = true;
      }else if (code == "TASKEDT") {
        edtTaskElem = $(".Re_assignedToVal");
        insertTpl = "${value}" + '';
        acceptSpaceBar = true;
        suffix = "";
        attdplysec = true;
        highlightFirst = true;
      }else if (code == "AGTASKEDT") {
        editTask = $(".Re_assignedToVal");
        insertTpl = "${value}" + '';
        acceptSpaceBar = true;
        suffix = "";
        attdplysec = true;
        highlightFirst = true;
      }else if (code == "TASKA") {
        edtTaskElem = $(".assignedToVal");
        insertTpl = "${value}" + '';
        acceptSpaceBar = true;
        suffix = "";
        attdplysec = true;
        highlightFirst = true;
      }
      else {
        elem = $(obj);
        
        highlightFirst = true;
        if ($(obj).attr("entitytype") == environment.taskEntityType) {
          insertTpl = "${value},";
        } else {
          insertTpl = "${value}";
        }
        suffix = " ";
      }
      //
      if (code == "ATT") {
        
        var dup_facilitatorvalues = this.utilService.checkduplicateModernAttendee(attElem.find(".para-container"));
        dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".para-container"));
        
        
      } else if (code == "EDTATT") {
        
        var dup_facilitatorvalues = this.utilService.checkduplicateEditAttendee(attElem.find(".para-container"));
        dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".para-container"));
      } else if (code == "TASKEDT") {
        
        var dup_facilitatorvalues =  this.utilService.checkduplicateEditTaskAttendee(editTaskElem.find(".para-container"));
       // dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".para-container"));
      } else if (code == "TASKA") {
        
        var dup_facilitatorvalues =  this.utilService.checkduplicateEditTaskAttendee(editTaskElem.find(".para-container"));
       // dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".para-container"));
      }else if (code == "AGTASKEDT") {
        var dup_facilitatorvalues =  this.utilService.checkduplicateModernAttendee(editTask.find(".atwho-inserted"));
       // dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".para-container"));
      }else {
       
        var dup_facilitatorvalues = this.utilService.checkduplicateModernAttendee(elem.find(".atwho-inserted"));
        dup_facilitatorvalues += this.utilService.checkduplicateModernAttendee(taskAttElem.find(".atwho-inserted"));
      }
      if (code == "MOM") {
        
        var attDuplvalues = this.utilService.checkduplicateModernAttendee(attElem.find(".para-container"));
        attDupl = attDuplvalues.split(',');
      }
      if(code == "AG"){
       
        var attDuplvalues = this.utilService.checkduplicateModernAttendee(attElem.find(".para-container"));
        attDupl = attDuplvalues.split(',');
      }
      this.fetchUserListSource("").then((result: any) => {
        ////consolee.log("inside fetchuserList then>>>**"+JSON.stringify(result));
        var source: any = "";
        var resultLen = 0;
        if(result!=null && result!=undefined){
          resultLen = result.length;
        }
        
        // if(dup_facilitatorvalues!=undefined || attDuplvalues!=undefined){
        
          if(dup_facilitatorvalues!=undefined){
            
            var all_facilitatorvalues: any = dup_facilitatorvalues.split(',');
          // }else if(attDuplvalues!=undefined){
          //   attDupl = attDuplvalues.split(',');
          // }
        
        //alert("result>>>" + JSON.stringify(result));
          $.each(result, function (i, el) {
          
          if (id) {
            if (code == "MOM" || code == "AG") {//In case of mom section, need to remove duplicate of already selected person and meeting attendee as well
              
              var index = $.inArray(el["userId"]+"", attDupl);//remove duplicate of meeting attendee as well
              
              if (index != null && (index < 0)) {
                
                index = $.inArray(el["userId"]+"", all_facilitatorvalues);//remove duplicate of already selected person
                
              }
            } else {
              var index = $.inArray(el["userId"] + "", all_facilitatorvalues);
            }
          } else {
            var index = -1;
          }
          if (index != null && (index < 0)) {
            var newname = "";
            if (el["userLastname"] != '') {
              newname = el["userFirstname"] + " " + el["userLastname"];
            } else {
              newname = el["userFirstname"];
            }
            source += '{"value":"' + newname.trim() + '","label":"'
              + newname + '-' + el["userEmail"] + '","email":"' + el["userEmail"]
              + '","id":"' + el["userId"] + '","isExternal":"' + el["userIsExternal"] + '"}';
          }
          if (i != resultLen - 1) {
            if (source.substring(source.length - 1, source.length) != ",") {
              source += ",";
            }
          }
        });
      }
        if (source != null && source != "") {
          //added for checking last character comma (,) or not, if it comma then replace with empty
          if (source.charAt(source.length - 1) == ',') {
            source = source.substr(0, source.length - 1);
          }
          if (source[0] == ",") {
            source = source.substring(1, source.length);
          }
          if (source != null && source != "" && source != "null" && source != undefined) {
            source = "[" + source + "]";
          }
        }
        if (source == null || source == "" || source == "null" || source == undefined || source == "undefined") {
          source = "[]";
        }
        if (source != null && source != "" && source != "null" && source != undefined) {
          //alert("source json values***"+JSON.stringify(source));
          source = JSON.parse(source);
          if (code == "MOM" || code == "AG") {
        
            //var source2: any = [];//[{ "value": "Mahalakshmi S", "isExternal": "0", "email": "smahalakshmi@chn.aithent.com", "label": "Mahalakshmi S-smahalakshmi@chn.aithent.com", "id": "523" }, { "value": "Praveen Putta", "isExternal": "0", "email": "ppraveen@chn.aithent.com", "label": "Praveen Putta-ppraveen@chn.aithent.com", "id": "212" }];
            var source2: any = this.loadMeetingParticipantJson();
            
            var emptyUsers: any = [];
            if (id) {
              $.each(source2, function (index, srcVal) {
                if (srcVal.id == "0" || srcVal.id == "") {
                  emptyUsers.push(source2[index]);//users without userId
                }
              });
              elem.find(".atwho-inserted").each((index: any, elemVal: any) => {

                var elemId = $(this).attr("id");
                var elemText = $(this).text().trim();
                if (pageIns.utilService.stringEndsWith(elemText, ",")) {

                  elemText = elemText.substring(0, elemText.length - 1);

                }

                if (elemId == "0" || elemId == "") {
                  emptyUsers = emptyUsers.filter(function (e: any) {
                    return (e.value != null && e.value != "" && e.value != "null" && e.value != undefined && e.value.trim() != elemText.trim());//Remove duplicate also from meeting participant
                  });
                }
              });
              $.each(all_facilitatorvalues, function (dupIndex, dupVal) {

                source2 = source2.filter(function (e: any) {
                  return (e.id !== dupVal && e.id != "0");//Remove duplicate also from meeting participant
                });
              });
            }
            var margeSrc = $.merge(source2, emptyUsers);
            var allSource = $.merge(margeSrc, source);
            source = allSource;
          }
        }
        //this.globals.globalAgendaPresenterSource = source;
        if (source == null || source == "" || source == "null" || source == undefined || source == "undefined") {
          source = [];
        }
        //
        var options = {
          at: "@",
          show_the_at: true,
          insertTpl: insertTpl,
          startWithSpace: false,
          headerTpl: '<div class="atwho-header">Users List<small>↑&nbsp;↓&nbsp;</small></div>',
          displayTpl: "<li email='${email}' id='${id}' userName='${value}'>${value}<br/><small>${email}</small></li>",
          spaceSelectsMatch: false,
          data: source,
          searchKey: "label",
          acceptSpaceBar: acceptSpaceBar,
          suffix: suffix,
          attdplysec: attdplysec,
          highlightFirst: highlightFirst,

          callbacks: {
            afterMatchFailed: function (at:any, el:any) {
              // 32 is spacebar
              //
              if (at == '@') {
                //
                var newTag = el.text().trim().slice(1);
                
                var newData = el.text().trim();
                //
               
              }
            },
          },
        };
        if (edtElem != null) {
          
          var $inputor = edtElem.atwho(options);
        } else if(elem!=null) {
          
          var $inputor = elem.atwho(options);
        }else if(edtTaskElem!=null) {
         
          var $inputor = edtTaskElem.atwho(options);
        }else if(editTask!=null) {
           var $inputor = editTask.atwho(options);
         }
        //$inputor.atwho('load', options, source).atwho('run');
        resolve($inputor);
      });
    });

  }

  //Method to load user list source
  fetchUserListSource(reload: any) {
    ////consolee.log("inside fetchuserList>>")
    return new Promise((resolve, reject) => {
      if (reload == "Y" || this.globals.globalUserListSource==null || (this.globals.globalUserListSource!=null && this.globals.globalUserListSource.length <= 0)) {
        this.loadUserDetails().subscribe((result: any) => {
          this.globals.globalUserListSource = result;
          resolve(this.globals.globalUserListSource);
        });
      } else {
        resolve(this.globals.globalUserListSource);
      }
    });

  }
//Method to create Meeting participant json
loadMeetingParticipantJson(){
  
  var jsonObj:any = [];
  var pageIns = this;
  $("#displayAttendeeSec").find(".para-container").each(function(){
    var attDetail :any = {};
    var name = "";
    if($(this).text()!=null && $(this).text()!="" && $(this).text()!=undefined && $(this).text()!="null"){
      attDetail.value = pageIns.utilService.removeLastString($(this).text(),"<br>");
      name = pageIns.utilService.removeLastString($(this).text(),"<br>");
    }else{
      attDetail.value = "";
    }
    if($(this).attr("isExternal")!=null  && $(this).attr("isExternal")!="" && $(this).attr("isExternal")!=undefined && $(this).attr("isExternal")!="null"){
      attDetail.isExternal = $(this).attr("isExternal");
    }else{
      attDetail.isExternal = "1";
    }
    if($(this).attr("attendeeEmail")!=null  && $(this).attr("attendeeEmail")!="" && $(this).attr("attendeeEmail")!=undefined && $(this).attr("attendeeEmail")!="null"){
      attDetail.email = $(this).attr("attendeeEmail");
      attDetail.label = name+"-"+$(this).attr("attendeeEmail");
    }else{
      attDetail.label = name;
      attDetail.email = "";
    }
    if($(this).attr("fkuserid")!=null  && $(this).attr("fkuserid")!="" && $(this).attr("fkuserid")!=undefined && $(this).attr("fkuserid")!="null" && $(this).attr("fkuserid")!="0"){
      attDetail.id = $(this).attr("fkuserid");
    }else{
      attDetail.id = "";
    }
    jsonObj.push(attDetail);
    
  });

  $("#accordion-header-attendee-0").find(".para-container").each(function(){
    var attDetail :any = {};
    var name = "";
    if($(this).text()!=null && $(this).text()!="" && $(this).text()!=undefined && $(this).text()!="null"){
      attDetail.value = pageIns.utilService.removeLastString($(this).text(),"<br>");
      name = pageIns.utilService.removeLastString($(this).text(),"<br>");
    }else{
      attDetail.value = "";
    }
    if($(this).attr("isExternal")!=null  && $(this).attr("isExternal")!="" && $(this).attr("isExternal")!=undefined && $(this).attr("isExternal")!="null"){
      attDetail.isExternal = $(this).attr("isExternal");
    }else{
      attDetail.isExternal = "1";
    }
    if($(this).attr("attendeeEmail")!=null  && $(this).attr("attendeeEmail")!="" && $(this).attr("attendeeEmail")!=undefined && $(this).attr("attendeeEmail")!="null"){
      attDetail.email = $(this).attr("attendeeEmail");
      attDetail.label = name+"-"+$(this).attr("attendeeEmail");
    }else{
      attDetail.label = name;
      attDetail.email = "";
    }
    if($(this).attr("fkuserid")!=null  && $(this).attr("fkuserid")!="" && $(this).attr("fkuserid")!=undefined && $(this).attr("fkuserid")!="null" && $(this).attr("fkuserid")!="0"){
      attDetail.id = $(this).attr("fkuserid");
    }else{
      attDetail.id = "";
    }
    jsonObj.push(attDetail);
  
  });
  return jsonObj;
}


}
